/**
 * Environment Configuration
 *
 * Centralized configuration for environment variables
 */

export const config = {
  // API Configuration
  apiBaseURL: process.env.REACT_APP_API_URL || '/api',

  // Third-party API Keys
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID || '',

  // App Settings
  appName: 'Touchline Memories',
  appVersion: process.env.REACT_APP_VERSION || '1.0.0',
  environment: process.env.NODE_ENV || 'development',

  // Feature Flags
  enableGoogleOAuth: process.env.REACT_APP_ENABLE_GOOGLE_OAUTH !== 'false',
  enableStripe: process.env.REACT_APP_ENABLE_STRIPE !== 'false',
  enablePayPal: process.env.REACT_APP_ENABLE_PAYPAL !== 'false',
  enableNewsletter: process.env.REACT_APP_ENABLE_NEWSLETTER !== 'false',
  enableStripePaymentIntent: process.env.REACT_APP_ENABLE_STRIPE_PAYMENT_INTENT === 'true',

  // Development Settings
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  isTest: process.env.NODE_ENV === 'test',

  // Logging
  enableDebugLogs: process.env.REACT_APP_DEBUG === 'true'
};

// Helper to log configuration in development
if (config.isDevelopment && config.enableDebugLogs) {
  console.log('[Config] Environment configuration:', {
    environment: config.environment,
    apiBaseURL: config.apiBaseURL
  });
}
